import './App.css';
import TopBar from './components/TopBar';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import StatsSection from './components/StatsSection';
import AboutUs from './components/AboutUs';
import AirportTransfer from './components/AirportTransfer';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import ServiceDetail from './components/ServiceDetail';
import servicesData from './data/servicesData';
import Testimonials from './components/Testimonials';
import MobileQuickActions from './components/MobileQuickActions';

const HomePage = () => {
  return (
    <>
      <Hero />
      <Features />
      <StatsSection />
      <AboutUs />
      <AirportTransfer />
      <ContactUs />
      <Testimonials />
    </>
  );
};

function App() {
  const pathName = window.location.pathname;
  const serviceMatch = pathName.match(/^\/services\/([^/]+)\/?$/);
  const serviceSlug = serviceMatch ? decodeURIComponent(serviceMatch[1]) : null;
  const currentService = serviceSlug
    ? servicesData.find((item) => item.slug === serviceSlug)
    : null;

  return (
    <div className="App">
      <TopBar />
      <Header />
      {serviceSlug ? (
        <>
          <Hero title={currentService ? currentService.title : 'Your Journey Starts Here'} />
          <ServiceDetail serviceSlug={serviceSlug} />
          <ContactUs />
        </>
      ) : (
        <HomePage />
      )}
      <MobileQuickActions />
      <Footer />
    </div>
  );
}

export default App;
